import { gql } from '@apollo/client';
import { SaleItemForPickerFragment } from 'graphql/Deal/fragments/dealItemPicker/SaleItemForPickerFragment';
/**
 * @const SaleItemQuery
 * @since 1.0.0
 */
export const SaleItemQuery = gql `
  query SaleItemQuery($input: SaleItemInput!) {
    saleItem(input: $input) {
      ...SaleItemForPickerFragment
    }
  }

  ${SaleItemForPickerFragment}
`;
